export default __webpack_public_path__ + "static/media/ic_star_primary.1cab4e3b.svg";